import React from 'react'
import { Link as DSLink } from '@nespresso-design-system/components'
import { Link as LinkProps } from '@commons/drupal.types'
import { selectPromotion } from '@content/helpers/src/gtmEvents.js'
import { CampaignProps } from '@commons/types.ts'

const Link = ({
    link,
    label,
    size,
    variant,
    config,
    onClick,
    tracking_select_promotion,
    campaign
}: LinkProps & {
    onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
    tracking_select_promotion?: string
    campaign?: CampaignProps
}) => {
    if (!label) {
        return null
    }

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        if (tracking_select_promotion && campaign) {
            selectPromotion({
                cta_name: tracking_select_promotion,
                ...campaign
            })
        }

        onClick?.(event)
    }

    return (
        <DSLink
            icon={config?.icon}
            iconPosition={config?.iconPosition}
            isDecorative={config?.isDecorative}
            label={label}
            size={size}
            variant={variant}
            href={link}
            target={config?.target_blank ? '_blank' : '_self'}
            hasUnderline={config?.hasUnderline}
            className={config?.className}
            onClick={handleClick}
        />
    )
}

export default Link
